import applicationGraphs from '@/utils/templates/smTemplate/application.graphs.config';

const sm = {
  application: [
    applicationGraphs.lineCharts,
    applicationGraphs.barCharts,
    applicationGraphs.heatMaps
  ]
};
export default sm;
